
import Vue from "vue";
import { AjaxGet, AjaxPost } from "@/App.vue";
import { GetTermsAndConditionsURL } from "../../../shared/Shared";

export default Vue.extend({
    name: "TermsAndConditions",
    data() {
        return {
            tnc: ""
        };
    },
    created() {

        const context = this;
        AjaxGet<string>(GetTermsAndConditionsURL(), true).then((result) => {
            context.tnc = result;
        });
    },

    methods: {
        save() {
            AjaxPost(GetTermsAndConditionsURL(), ({
                tnc: this.tnc
            }), true).then(() => {
                // Save completed
            });
        }
    }
});
